export default __webpack_public_path__ + "static/media/TAP_plus_3.bb9c9a3b.gif";